import { Dialog } from 'components/Dialog';
import Stepper from 'components/Stepper';
import DisplayText from 'components/ui-kits/DisplayText';
import React, { useState } from 'react';
import styled from 'styled-components';

const Link = styled.a`
  text-decoration: underline;
`;

const RetrySubscribePlanModal = ({
  retryFn,
  defaultShow
}: {
  retryFn: (args?: any) => void;
  defaultShow?: boolean;
}) => {
  const [isShow, setIsShow] = useState(defaultShow || false);

  const closeModal = () => setIsShow(false);

  const step: React.ComponentPropsWithoutRef<typeof Stepper>['steps'] = [
    {
      id: 'asd',
      header: 'Le paiement a échoué',
      headerButtonConfig: {
        closeButton: {
          hideCloseButton: true,
          onClick: closeModal
        }
      },
      content: (
        <>
          <DisplayText fontSize="L" color="BLACK_6">
            Une erreur s&apos;est produite lors du paiement. Veuillez vérifier
            vos coordonnées bancaires et réessayer.
          </DisplayText>
          <DisplayText fontSize="L" color="BLACK_6" margin="1rem 0">
            Si le problème persiste, contactez{' '}
            <Link href="mailto:support.commercant@achil.com">
              support.commercant@achil.com
            </Link>
          </DisplayText>
        </>
      ),
      footerConfig: {
        previousButton: {
          label: 'Retour',
          onClick: closeModal
        },
        nextButton: { label: 'Recommencer', onClick: retryFn }
      }
    }
  ];

  if (!isShow) {
    return null;
  }

  return (
    <Dialog maxWidth="55rem" zIndex={600}>
      <Stepper steps={step} />
    </Dialog>
  );
};

export default RetrySubscribePlanModal;
